// Types for the assessment Overview screen. These define the API response contract
// shared between the API (which builds the payload) and the web app (which renders it).
export var SectionCompletionState;
(function (SectionCompletionState) {
    SectionCompletionState["NotStarted"] = "not_started";
    SectionCompletionState["InProgress"] = "in_progress";
    SectionCompletionState["Complete"] = "complete";
})(SectionCompletionState || (SectionCompletionState = {}));
/** Submission conditions in the order the UI lists them; the wire values for JSON-schema enums. */
export const SUBMIT_GATE_CONDITIONS = [
    'terms',
    'org_profile',
    'required_sections',
    'deadline',
];
//# sourceMappingURL=assessment-overview.js.map